/* GoLite — dikişli / dikişsiz eşleri tek ürün gibi gösterir; tüm ürün kartlarında görseller döner (01.10.2026); gizli Lito bulununca ses (28.09.2026). golite-lito.liquid içinden yüklenir. */
(function(){ var st = document.createElement('style'); st.textContent = ".gl-dikis{margin-top:0}\n.gl-dikis__note{margin:.2rem 0 0;font-size:1.3rem;color:rgba(var(--color-foreground),.65)}\n.gl-dikis-sub{display:block;margin-top:.2rem;font-size:1.25rem;letter-spacing:.04rem;color:rgba(var(--color-foreground),.6)}\n.gl-dikis-hide{display:none!important}\n.gl-rot{position:absolute;inset:0;z-index:1;pointer-events:none;transition:opacity .3s}\n.gl-rot img{position:absolute;inset:0;width:100%!important;height:100%!important;object-fit:cover;opacity:0;transition:opacity .7s ease}\n.gl-rot img.is-on{opacity:1}\n.card-wrapper:hover .gl-rot.has-hover{opacity:0}\n@media (prefers-reduced-motion:reduce){.gl-rot img{transition:none}}\n.gl-dikis--rb{border:0;margin:1rem 0 .4rem;padding:0;min-width:0}\n.gl-dikis--rb legend{padding:0;margin:0 0 .8rem;font-size:1.4rem;color:#333}\n.gl-dikis--rb .gl-dikis__it{display:flex;flex-wrap:wrap;gap:.8rem}\n.gl-dikis--rb input{position:absolute;opacity:0;width:1px;height:1px;pointer-events:none}\n.gl-dikis--rb label{display:inline-flex;align-items:center;justify-content:center;min-width:5rem;padding:.8rem 1.6rem;border:1px solid #e6e6e6;background:#fff;color:#333;font-size:1.4rem;letter-spacing:.063rem;cursor:pointer;transition:border-color .15s}\n.gl-dikis--rb label:hover{border-color:#333}\n.gl-dikis--rb input:checked+label{background:#333;color:#fff;border-color:#1a1a1a}\n.gl-dikis--rb input:focus-visible+label{outline:2px solid #333;outline-offset:2px}"; (document.head || document.documentElement).appendChild(st); })();
(function(){ function glDikis(){
  var PAIRS = {'golite-poliuretan-mousepad': 'golite-poliuretan-mousepad-dikisli', 'golite-suni-deri-mousepad': 'golite-suni-deri-dikisli-mousepad'};
  var SIB = {}; Object.keys(PAIRS).forEach(function(k){ SIB[k] = {h: PAIRS[k], d: false}; SIB[PAIRS[k]] = {h: k, d: true}; });
  function handleOf(href){ var m = (href || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  var cache = {};
  function prod(h){ return cache[h] || (cache[h] = fetch('/products/' + h + '.js').then(function(r){ return r.json(); })); }

  /* ürün sayfası */
  var HANDLE = handleOf(location.pathname);
  function pick(v, list){
    var av = list.filter(function(x){ return x.available; }); if (!av.length) av = list;
    function f(fn){ for (var i = 0; i < av.length; i++) if (fn(av[i])) return av[i]; }
    return (v && (f(function(x){ return x.option1 === v.option1 && x.option2 === v.option2; }) || f(function(x){ return x.option1 === v.option1; }) || f(function(x){ return x.option2 === v.option2; }))) || av[0];
  }
  function cur(){ var el = document.querySelector('variant-selects [data-selected-variant]'); try { return el ? JSON.parse(el.textContent) : null; } catch(e){ return null; } }
  function build(){
    var s = SIB[HANDLE]; if (!s) return;
    /* Rubik swatch uygulaması kendi seçicisini gösterip temanınkini gizliyorsa onun görünümüne uyulur */
    var vs0 = document.querySelector('variant-selects'), rb = !!(vs0 && getComputedStyle(vs0).display === 'none'), old = document.querySelector('.gl-dikis');
    if (old) { if (old.classList.contains('gl-dikis--rb') === rb) return; old.remove(); }
    var vs = document.querySelector('variant-selects'), q = document.querySelector('.product-form__quantity');
    var ref = q && q.parentNode ? q : (vs ? vs.nextSibling : null), host = q && q.parentNode ? q.parentNode : (vs ? vs.parentNode : null);
    if (!host) return;
    var fs = document.createElement('fieldset'); fs.className = rb ? 'gl-dikis gl-dikis--rb' : 'js product-form__input product-form__input--pill gl-dikis';
    var on = s.d ? 'Dikişli' : 'Dikişsiz', id = 'gl-dikis-' + Math.random().toString(36).slice(2, 7);
    fs.innerHTML = '<legend class="form__label">Dikiş: ' + on + '</legend>' +
      (rb ? '<div class="gl-dikis__it">' : '') +
      ['Dikişsiz', 'Dikişli'].map(function(t, i){ return '<input type="radio" id="' + id + i + '" value="' + t + '"' + (t === on ? ' checked' : '') + '><label for="' + id + i + '">' + t + '</label>'; }).join('') +
      (rb ? '</div>' : '') +
      '<p class="gl-dikis__note">' + (s.d ? 'Kenarları dikişlidir; yıpranmaya ve püskülenmeye karşı daha dayanıklıdır.' : 'Dikişli seçenekte kenarlar dikişlidir; yıpranmaya karşı daha dayanıklıdır.') + '</p>';
    if (!s.d) prod(s.h).then(function(p){
      var o = (p.options || []).filter(function(x){ return /boyut/i.test(x.name || x); })[0], n = fs.querySelector('.gl-dikis__note');
      if (o && o.values && n && !/ölçü/.test(n.textContent)) n.textContent += ' Dikişli ölçüler: ' + o.values.join(', ') + '.';
    }).catch(function(){});
    host.insertBefore(fs, ref);
    fs.addEventListener('change', function(e){
      e.stopPropagation(); var t = e.target; if (!t || t.value === on) return;
      prod(s.h).then(function(p){ var v = pick(cur(), p.variants); location.href = '/products/' + s.h + (v ? '?variant=' + v.id : ''); })
        .catch(function(){ location.href = '/products/' + s.h; });
    });
  }
  if (SIB[HANDLE]) {
    build();
    var bt; new MutationObserver(function(){ clearTimeout(bt); bt = setTimeout(build, 60); }).observe(document.body, {childList: true, subtree: true});
    prod(SIB[HANDLE].h);
  }


  /* ürün kartlarında görsel sırayla değişir: varyantı olan üründe stoktaki renk/boyut fotoğrafları,
     tek varyantlı ürünlerde dönmez; birleşik (dikişli/dikişsiz) kartta iki ürünün varyantları (01.10.2026) */
  var POOL = {};
  /* görseli dönmesin istenen ürünler (handle) */
  var NOROT = {};
  function norm(u){ return (u || '').replace(/^https?:/, ''); }
  function shuffle(a){ for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function vimgs(p, seen, out){
    p.variants.forEach(function(v){
      var src = norm(v.featured_image && v.featured_image.src); if (!src || !v.available) return;
      var k = src.split('?')[0]; if (seen[k]) return; seen[k] = 1; out.push(src);
    });
  }
  function pool(h){
    if (POOL[h]) return POOL[h];
    var hs = PAIRS[h] ? [h, PAIRS[h]] : [h];
    return (POOL[h] = Promise.all(hs.map(function(x){ return prod(x).catch(function(){ return null; }); })).then(function(ps){
      var seen = {}, out = [];
      ps.forEach(function(p){ if (p && p.variants) vimgs(p, seen, out); });
      /* yalnızca birden çok renk/varyant fotoğrafı olan ürünlerde döner; tek varyantlı üründe (galeri, bilgi görselleri) döndürülmez */
      return out.length >= 2 ? shuffle(out) : [];
    }));
  }
  function sized(src){ return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800'; }
  function rotate(c, h){
    if (c.getAttribute('data-gl-rot')) return; c.setAttribute('data-gl-rot', '1');
    var m = c.querySelector('.card__media .media') || c.querySelector('.card__media'); if (!m) return;
    rot(m, function(){ return pool(h); });
  }
  function rot(m, getList){
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var list = null, started = false, i = 0, front = null, A, B, vis = false, t = null, gap = 2600 + Math.floor(Math.random() * 900);
    function build(){
      var w = document.createElement('div'); w.className = 'gl-rot' + (m.querySelectorAll('img').length > 1 ? ' has-hover' : '');
      A = document.createElement('img'); B = document.createElement('img'); A.alt = B.alt = ''; A.decoding = B.decoding = 'async';
      w.appendChild(A); w.appendChild(B); m.appendChild(w); front = A;
    }
    function next(){
      t = null; if (!vis || document.hidden || !list) return;
      var back = front === A ? B : A, src = sized(list[i++ % list.length]), pre = new Image();
      pre.onload = function(){ back.src = src; back.classList.add('is-on'); front.classList.remove('is-on'); front = back; t = setTimeout(next, gap); };
      pre.onerror = function(){ t = setTimeout(next, 400); };
      pre.src = src;
    }
    function go(){
      if (!vis || document.hidden) return;
      if (!started) { started = true; getList().then(function(l){ if (l.length < 2) return; list = l; build(); go(); }); return; }
      if (list && !t) t = setTimeout(next, 900 + Math.floor(Math.random() * 1400));
    }
    if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ vis = es[0].isIntersecting; go(); }, {threshold: .3}).observe(m); else { vis = true; go(); }
    document.addEventListener('visibilitychange', go);
  }
  /* koleksiyon ve listelerde: iki kart da varsa dikişli kartı gizle, dikişsiz karta not ekle */
  function merge(){
    var cards = {};
    document.querySelectorAll('.card-wrapper').forEach(function(c){
      var a = c.querySelector('a[href*="/products/"]'); if (!a) return;
      var h = handleOf(a.getAttribute('href')); if (!SIB[h]) return;
      (cards[h] = cards[h] || []).push(c);
    });
    Object.keys(PAIRS).forEach(function(b){
      var d = PAIRS[b]; if (!cards[b]) return;
      cards[b].forEach(function(c){
        var t = c.querySelector('.card__information .card__heading.h5') || c.querySelector('.card__information .card__heading') || c.querySelector('.card__heading'); if (!t || c.querySelector('.gl-dikis-sub')) return;
        var sp = document.createElement('span'); sp.className = 'gl-dikis-sub'; sp.textContent = 'Dikişli ve dikişsiz seçenekli'; t.parentNode.insertBefore(sp, t.nextSibling);
      });
      (cards[d] || []).forEach(function(c){
        var li = c.closest('li.grid__item, .grid__item, li') || c;
        var grid = li.parentNode;
        if (grid && cards[b].some(function(x){ return grid.contains(x); })) li.classList.add('gl-dikis-hide');
      });
    });
    document.querySelectorAll('.card-wrapper').forEach(function(c){
      if (c.getAttribute('data-gl-rot') || c.closest('.gl-dikis-hide')) return;
      var a = c.querySelector('a[href*="/products/"]'); if (!a) return;
      var hr = a.getAttribute('href') || '', h = handleOf(hr); if (h && !NOROT[h] && hr.indexOf('variant=') < 0) rotate(c, h);
    });
  }
  merge();

  /* Bilek desteği sayfasındaki büyük iki görsel (glcb-hero): solda melek kanat / yaprak, sağda bulut ürünlerinin renkleri döner */
  var HERO = [['golite-melek-kanat-sekilli-klavye-bilek-destek', 'golite-yaprak-sekilli-klavye-bilek-destek', 'golite-melek-kanat-sekilli-mouse-bilek-destek'],
              ['golite-bulut-sekilli-klavye-bilek-destek', 'golite-bulut-sekilli-mouse-bilek-destek', 'golite-bulut-sekilli-bilek-destek-set']];
  function heroPool(hs){
    var key = 'hero:' + hs.join(',');
    return POOL[key] || (POOL[key] = Promise.all(hs.map(function(x){ return prod(x).catch(function(){ return null; }); })).then(function(ps){
      var seen = {}, out = []; ps.forEach(function(p){ if (p && p.variants) vimgs(p, seen, out); }); return shuffle(out);
    }));
  }
  function hero(){
    document.querySelectorAll('.glcb-hero__media figure').forEach(function(f, k){
      if (f.getAttribute('data-gl-rot') || !HERO[k]) return; f.setAttribute('data-gl-rot', '1');
      if (getComputedStyle(f).position === 'static') f.style.position = 'relative';
      rot(f, function(){ return heroPool(HERO[k]); });
    });
  }
  hero(); setTimeout(hero, 1500);
  var mt; new MutationObserver(function(){ clearTimeout(mt); mt = setTimeout(merge, 200); }).observe(document.documentElement, {childList: true, subtree: true});
} if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', glDikis); else glDikis(); })();

/* Gizli Lito bulununca kısa neşeli ses (dosya yok, tarayıcıda sentezlenir; tıklamayla başladığı için telefonda da çalar) */
(function(){
  var ac = null;
  function sfx(){
    try {
      var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
      ac = ac || new AC(); if (ac.state === 'suspended') ac.resume();
      var t = ac.currentTime + .02, out = ac.createGain(); out.gain.value = .18; out.connect(ac.destination);
      [[784, 0], [988, .08], [1175, .16], [1568, .24], [2093, .36]].forEach(function(n, i){
        var o = ac.createOscillator(), g = ac.createGain();
        o.type = i === 4 ? 'sine' : 'triangle'; o.frequency.setValueAtTime(n[0], t + n[1]);
        if (i === 4) o.frequency.exponentialRampToValueAtTime(2637, t + n[1] + .25);
        g.gain.setValueAtTime(0, t + n[1]); g.gain.linearRampToValueAtTime(1, t + n[1] + .012);
        g.gain.exponentialRampToValueAtTime(.001, t + n[1] + (i === 4 ? .5 : .22));
        o.connect(g); g.connect(out); o.start(t + n[1]); o.stop(t + n[1] + .55);
      });
    } catch(e){}
  }
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest && e.target.closest('.lito-egg__b'); if (!b) return;
    var w = b.closest('.lito-egg'); if (w && !w.classList.contains('is-found')) sfx();
  }, true);
})();

/* Ürün sayfası düzeltmeleri (28.09.2026):
   1) Seçili varyantın fotoğrafı galerinin başında değilse başa alınır (telefonda ilk açılışta yanlış renk görünmesin).
   2) Rubik renk kutuları satırı boş bırakmadan tüm genişliğe eşit dağılır. */
(function(){
  if (!/\/products\//.test(location.pathname)) return;
  var RUBIK_CSS = '.rubik-swatch__items--visual{display:grid!important;grid-template-columns:repeat(auto-fill,minmax(64px,1fr));gap:8px}' +
    '.rubik-swatch__items--visual .rubik-swatch__item-wrapper{width:auto!important;min-width:0}' +
    '.rubik-swatch__items--visual .rubik-swatch__label--image{width:100%!important;height:auto!important;aspect-ratio:1/1}' +
    '.rubik-swatch__items--visual .rubik-swatch__image{width:calc(100% - 2px)!important;height:calc(100% - 2px)!important;object-fit:contain}' +
    '.rubik-swatch__items--visual .rubik-swatch__caption,.rubik-swatch__items--visual .rubik-swatch__text-label{width:100%!important}';
  function rubik(){
    document.querySelectorAll('rubik-swatch').forEach(function(h){
      var sr = h.shadowRoot; if (!sr || sr.querySelector('style[data-gl]')) return;
      var st = document.createElement('style'); st.setAttribute('data-gl', ''); st.textContent = RUBIK_CSS; sr.appendChild(st);
    });
  }
  var fixed = false;
  function gallery(){
    if (fixed) return;
    var a = document.querySelector('.product__media-list .product__media-item.is-active'); if (!a) return;
    var list = a.parentElement; if (list.firstElementChild === a) return;
    list.insertBefore(a, list.firstElementChild);
    var s = list.closest('slider-component') ? list : null; if (s) s.scrollLeft = 0;
  }
  function run(){ rubik(); gallery(); }
  run();
  var t; new MutationObserver(function(){ clearTimeout(t); t = setTimeout(run, 80); }).observe(document.documentElement, {childList: true, subtree: true});
  setTimeout(function(){ fixed = true; }, 6000);
})();
